module.exports = __webpack_public_path__ + "img/green-rocket_sl.ba30020b.svg";